import { FundsService_fundsServiceGetEntities } from '@festina/unitlink-general-types/unitlink/hooks/FundsService_fundsServiceGetEntities'

export const useFetchFunds =
  FundsService_fundsServiceGetEntities.useSuspenseQuery
